const FormUtils = module.exports = {};

Object.assign(
    FormUtils,
    require('./core'),
    require('./context'),
    require('./componentRegistry'),
    require('./config'),
    require('./error'),
    require('./focus'),
    require('./group'),
    require('./hooks'),
    require('./layout'),
    require('./lifecycle'),
    require('./progress'),
    require('./renderer'),
    require('./state'),
    require('./value'),
    require('./ageUtils'),
    require('./validation'),
    require('./onChange')
);
